// source: acompanha/feature_flags/v1/feature_flags.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest', null, global);
goog.exportSymbol('proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse', null, global);
goog.exportSymbol('proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest', null, global);
goog.exportSymbol('proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse', null, global);
goog.exportSymbol('proto.acompanha.feature_flags.v1.EvaluatedFeature', null, global);
goog.exportSymbol('proto.acompanha.feature_flags.v1.FeatureFlag', null, global);
goog.exportSymbol('proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser', null, global);
goog.exportSymbol('proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest', null, global);
goog.exportSymbol('proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse', null, global);
goog.exportSymbol('proto.acompanha.feature_flags.v1.GetFeatureFlagRequest', null, global);
goog.exportSymbol('proto.acompanha.feature_flags.v1.GetFeatureFlagResponse', null, global);
goog.exportSymbol('proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest', null, global);
goog.exportSymbol('proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse', null, global);
goog.exportSymbol('proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest', null, global);
goog.exportSymbol('proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse', null, global);
goog.exportSymbol('proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest', null, global);
goog.exportSymbol('proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.displayName = 'proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.feature_flags.v1.FeatureFlag = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.feature_flags.v1.FeatureFlag.repeatedFields_, null);
};
goog.inherits(proto.acompanha.feature_flags.v1.FeatureFlag, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.feature_flags.v1.FeatureFlag.displayName = 'proto.acompanha.feature_flags.v1.FeatureFlag';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.feature_flags.v1.EvaluatedFeature = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.feature_flags.v1.EvaluatedFeature, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.feature_flags.v1.EvaluatedFeature.displayName = 'proto.acompanha.feature_flags.v1.EvaluatedFeature';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest.displayName = 'proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse.displayName = 'proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest.displayName = 'proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse.displayName = 'proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.feature_flags.v1.GetFeatureFlagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.feature_flags.v1.GetFeatureFlagRequest.displayName = 'proto.acompanha.feature_flags.v1.GetFeatureFlagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.feature_flags.v1.GetFeatureFlagResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.feature_flags.v1.GetFeatureFlagResponse.displayName = 'proto.acompanha.feature_flags.v1.GetFeatureFlagResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.displayName = 'proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse.displayName = 'proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.repeatedFields_, null);
};
goog.inherits(proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.displayName = 'proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse.displayName = 'proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest.displayName = 'proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse.displayName = 'proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest.displayName = 'proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse.displayName = 'proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.toObject = function(includeInstance, msg) {
  var f, obj = {
featureKey: jspb.Message.getFieldWithDefault(msg, 1, ""),
userUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
userName: jspb.Message.getFieldWithDefault(msg, 3, ""),
userEmail: jspb.Message.getFieldWithDefault(msg, 4, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser}
 */
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser;
  return proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser}
 */
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeatureKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserEmail(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFeatureKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUserEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string feature_key = 1;
 * @return {string}
 */
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.prototype.getFeatureKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser} returns this
 */
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.prototype.setFeatureKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_uuid = 2;
 * @return {string}
 */
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.prototype.getUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser} returns this
 */
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.prototype.setUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_name = 3;
 * @return {string}
 */
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser} returns this
 */
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string user_email = 4;
 * @return {string}
 */
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.prototype.getUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser} returns this
 */
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.prototype.setUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser} returns this
*/
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser} returns this
 */
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.feature_flags.v1.FeatureFlag.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.feature_flags.v1.FeatureFlag.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.feature_flags.v1.FeatureFlag} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.FeatureFlag.toObject = function(includeInstance, msg) {
  var f, obj = {
key: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
isBeta: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
planNamesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
allowlistList: jspb.Message.toObjectList(msg.getAllowlistList(),
    proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.toObject, includeInstance),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
showInMenu: jspb.Message.getBooleanFieldWithDefault(msg, 10, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlag}
 */
proto.acompanha.feature_flags.v1.FeatureFlag.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.feature_flags.v1.FeatureFlag;
  return proto.acompanha.feature_flags.v1.FeatureFlag.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.feature_flags.v1.FeatureFlag} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlag}
 */
proto.acompanha.feature_flags.v1.FeatureFlag.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsBeta(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addPlanNames(value);
      break;
    case 7:
      var value = new proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser;
      reader.readMessage(value,proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.deserializeBinaryFromReader);
      msg.addAllowlist(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowInMenu(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.feature_flags.v1.FeatureFlag.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.feature_flags.v1.FeatureFlag} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.FeatureFlag.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getIsBeta();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getPlanNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getAllowlistList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getShowInMenu();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlag} returns this
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlag} returns this
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlag} returns this
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool enabled = 4;
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlag} returns this
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool is_beta = 5;
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.getIsBeta = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlag} returns this
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.setIsBeta = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated string plan_names = 6;
 * @return {!Array<string>}
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.getPlanNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlag} returns this
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.setPlanNamesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlag} returns this
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.addPlanNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlag} returns this
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.clearPlanNamesList = function() {
  return this.setPlanNamesList([]);
};


/**
 * repeated FeatureFlagAllowlistUser allowlist = 7;
 * @return {!Array<!proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser>}
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.getAllowlistList = function() {
  return /** @type{!Array<!proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser, 7));
};


/**
 * @param {!Array<!proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser>} value
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlag} returns this
*/
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.setAllowlistList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser}
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.addAllowlist = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.acompanha.feature_flags.v1.FeatureFlagAllowlistUser, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlag} returns this
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.clearAllowlistList = function() {
  return this.setAllowlistList([]);
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlag} returns this
*/
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlag} returns this
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlag} returns this
*/
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlag} returns this
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool show_in_menu = 10;
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.getShowInMenu = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlag} returns this
 */
proto.acompanha.feature_flags.v1.FeatureFlag.prototype.setShowInMenu = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.feature_flags.v1.EvaluatedFeature.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.feature_flags.v1.EvaluatedFeature.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.feature_flags.v1.EvaluatedFeature} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.EvaluatedFeature.toObject = function(includeInstance, msg) {
  var f, obj = {
access: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
showInMenu: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.feature_flags.v1.EvaluatedFeature}
 */
proto.acompanha.feature_flags.v1.EvaluatedFeature.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.feature_flags.v1.EvaluatedFeature;
  return proto.acompanha.feature_flags.v1.EvaluatedFeature.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.feature_flags.v1.EvaluatedFeature} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.feature_flags.v1.EvaluatedFeature}
 */
proto.acompanha.feature_flags.v1.EvaluatedFeature.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccess(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowInMenu(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.feature_flags.v1.EvaluatedFeature.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.feature_flags.v1.EvaluatedFeature.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.feature_flags.v1.EvaluatedFeature} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.EvaluatedFeature.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getShowInMenu();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional bool access = 1;
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.EvaluatedFeature.prototype.getAccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.feature_flags.v1.EvaluatedFeature} returns this
 */
proto.acompanha.feature_flags.v1.EvaluatedFeature.prototype.setAccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool show_in_menu = 2;
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.EvaluatedFeature.prototype.getShowInMenu = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.feature_flags.v1.EvaluatedFeature} returns this
 */
proto.acompanha.feature_flags.v1.EvaluatedFeature.prototype.setShowInMenu = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest}
 */
proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest;
  return proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest}
 */
proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
dataMap: (f = msg.getDataMap()) ? f.toObject(includeInstance, proto.acompanha.feature_flags.v1.EvaluatedFeature.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse}
 */
proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse;
  return proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse}
 */
proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getDataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.acompanha.feature_flags.v1.EvaluatedFeature.deserializeBinaryFromReader, "", new proto.acompanha.feature_flags.v1.EvaluatedFeature());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.acompanha.feature_flags.v1.EvaluatedFeature.serializeBinaryToWriter);
  }
};


/**
 * map<string, EvaluatedFeature> data = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.acompanha.feature_flags.v1.EvaluatedFeature>}
 */
proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse.prototype.getDataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.acompanha.feature_flags.v1.EvaluatedFeature>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.acompanha.feature_flags.v1.EvaluatedFeature));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse} returns this
 */
proto.acompanha.feature_flags.v1.GetEvaluatedFeaturesResponse.prototype.clearDataMap = function() {
  this.getDataMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest}
 */
proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest;
  return proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest}
 */
proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.ListFeatureFlagsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.acompanha.feature_flags.v1.FeatureFlag.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse}
 */
proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse;
  return proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse}
 */
proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.feature_flags.v1.FeatureFlag;
      reader.readMessage(value,proto.acompanha.feature_flags.v1.FeatureFlag.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.feature_flags.v1.FeatureFlag.serializeBinaryToWriter
    );
  }
};


/**
 * repeated FeatureFlag data = 1;
 * @return {!Array<!proto.acompanha.feature_flags.v1.FeatureFlag>}
 */
proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.acompanha.feature_flags.v1.FeatureFlag>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.feature_flags.v1.FeatureFlag, 1));
};


/**
 * @param {!Array<!proto.acompanha.feature_flags.v1.FeatureFlag>} value
 * @return {!proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse} returns this
*/
proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.feature_flags.v1.FeatureFlag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.feature_flags.v1.FeatureFlag}
 */
proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.feature_flags.v1.FeatureFlag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse} returns this
 */
proto.acompanha.feature_flags.v1.ListFeatureFlagsResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.feature_flags.v1.GetFeatureFlagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.feature_flags.v1.GetFeatureFlagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
key: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.feature_flags.v1.GetFeatureFlagRequest}
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.feature_flags.v1.GetFeatureFlagRequest;
  return proto.acompanha.feature_flags.v1.GetFeatureFlagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.feature_flags.v1.GetFeatureFlagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.feature_flags.v1.GetFeatureFlagRequest}
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.feature_flags.v1.GetFeatureFlagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.feature_flags.v1.GetFeatureFlagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagRequest.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.feature_flags.v1.GetFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagRequest.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.feature_flags.v1.GetFeatureFlagResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.feature_flags.v1.GetFeatureFlagResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.feature_flags.v1.FeatureFlag.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.feature_flags.v1.GetFeatureFlagResponse}
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.feature_flags.v1.GetFeatureFlagResponse;
  return proto.acompanha.feature_flags.v1.GetFeatureFlagResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.feature_flags.v1.GetFeatureFlagResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.feature_flags.v1.GetFeatureFlagResponse}
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.feature_flags.v1.FeatureFlag;
      reader.readMessage(value,proto.acompanha.feature_flags.v1.FeatureFlag.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.feature_flags.v1.GetFeatureFlagResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.feature_flags.v1.GetFeatureFlagResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.feature_flags.v1.FeatureFlag.serializeBinaryToWriter
    );
  }
};


/**
 * optional FeatureFlag data = 1;
 * @return {?proto.acompanha.feature_flags.v1.FeatureFlag}
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.feature_flags.v1.FeatureFlag} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.feature_flags.v1.FeatureFlag, 1));
};


/**
 * @param {?proto.acompanha.feature_flags.v1.FeatureFlag|undefined} value
 * @return {!proto.acompanha.feature_flags.v1.GetFeatureFlagResponse} returns this
*/
proto.acompanha.feature_flags.v1.GetFeatureFlagResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.feature_flags.v1.GetFeatureFlagResponse} returns this
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.GetFeatureFlagResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
key: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
isBeta: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
planNamesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
showInMenu: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest}
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest;
  return proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest}
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsBeta(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addPlanNames(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowInMenu(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getIsBeta();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getPlanNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getShowInMenu();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool enabled = 4;
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool is_beta = 5;
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.prototype.getIsBeta = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.prototype.setIsBeta = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated string plan_names = 6;
 * @return {!Array<string>}
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.prototype.getPlanNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.prototype.setPlanNamesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.prototype.addPlanNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.prototype.clearPlanNamesList = function() {
  return this.setPlanNamesList([]);
};


/**
 * optional bool show_in_menu = 7;
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.prototype.getShowInMenu = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagRequest.prototype.setShowInMenu = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.feature_flags.v1.FeatureFlag.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse}
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse;
  return proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse}
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.feature_flags.v1.FeatureFlag;
      reader.readMessage(value,proto.acompanha.feature_flags.v1.FeatureFlag.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.feature_flags.v1.FeatureFlag.serializeBinaryToWriter
    );
  }
};


/**
 * optional FeatureFlag data = 1;
 * @return {?proto.acompanha.feature_flags.v1.FeatureFlag}
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.feature_flags.v1.FeatureFlag} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.feature_flags.v1.FeatureFlag, 1));
};


/**
 * @param {?proto.acompanha.feature_flags.v1.FeatureFlag|undefined} value
 * @return {!proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse} returns this
*/
proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse} returns this
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.CreateFeatureFlagResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
key: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
description: jspb.Message.getFieldWithDefault(msg, 3, ""),
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
isBeta: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
planNamesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
showInMenu: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest}
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest;
  return proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest}
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsBeta(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addPlanNames(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowInMenu(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getIsBeta();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getPlanNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getShowInMenu();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool enabled = 4;
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool is_beta = 5;
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.prototype.getIsBeta = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.prototype.setIsBeta = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated string plan_names = 6;
 * @return {!Array<string>}
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.prototype.getPlanNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.prototype.setPlanNamesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.prototype.addPlanNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.prototype.clearPlanNamesList = function() {
  return this.setPlanNamesList([]);
};


/**
 * optional bool show_in_menu = 7;
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.prototype.getShowInMenu = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest} returns this
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagRequest.prototype.setShowInMenu = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.feature_flags.v1.FeatureFlag.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse}
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse;
  return proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse}
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.feature_flags.v1.FeatureFlag;
      reader.readMessage(value,proto.acompanha.feature_flags.v1.FeatureFlag.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.feature_flags.v1.FeatureFlag.serializeBinaryToWriter
    );
  }
};


/**
 * optional FeatureFlag data = 1;
 * @return {?proto.acompanha.feature_flags.v1.FeatureFlag}
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.feature_flags.v1.FeatureFlag} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.feature_flags.v1.FeatureFlag, 1));
};


/**
 * @param {?proto.acompanha.feature_flags.v1.FeatureFlag|undefined} value
 * @return {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse} returns this
*/
proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse} returns this
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.UpdateFeatureFlagResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
key: jspb.Message.getFieldWithDefault(msg, 1, ""),
userUuid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest}
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest;
  return proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest}
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest} returns this
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_uuid = 2;
 * @return {string}
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest.prototype.getUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest} returns this
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserRequest.prototype.setUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.feature_flags.v1.FeatureFlag.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse}
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse;
  return proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse}
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.feature_flags.v1.FeatureFlag;
      reader.readMessage(value,proto.acompanha.feature_flags.v1.FeatureFlag.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.feature_flags.v1.FeatureFlag.serializeBinaryToWriter
    );
  }
};


/**
 * optional FeatureFlag data = 1;
 * @return {?proto.acompanha.feature_flags.v1.FeatureFlag}
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.feature_flags.v1.FeatureFlag} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.feature_flags.v1.FeatureFlag, 1));
};


/**
 * @param {?proto.acompanha.feature_flags.v1.FeatureFlag|undefined} value
 * @return {!proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse} returns this
*/
proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse} returns this
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.AddFeatureFlagUserResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
key: jspb.Message.getFieldWithDefault(msg, 1, ""),
userUuid: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest}
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest;
  return proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest}
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest} returns this
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_uuid = 2;
 * @return {string}
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest.prototype.getUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest} returns this
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserRequest.prototype.setUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.feature_flags.v1.FeatureFlag.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse}
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse;
  return proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse}
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.feature_flags.v1.FeatureFlag;
      reader.readMessage(value,proto.acompanha.feature_flags.v1.FeatureFlag.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.feature_flags.v1.FeatureFlag.serializeBinaryToWriter
    );
  }
};


/**
 * optional FeatureFlag data = 1;
 * @return {?proto.acompanha.feature_flags.v1.FeatureFlag}
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.feature_flags.v1.FeatureFlag} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.feature_flags.v1.FeatureFlag, 1));
};


/**
 * @param {?proto.acompanha.feature_flags.v1.FeatureFlag|undefined} value
 * @return {!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse} returns this
*/
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse} returns this
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.feature_flags.v1.RemoveFeatureFlagUserResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.acompanha.feature_flags.v1);
